<template>
  <transition name="modal">
    <div v-if="show" class="modal-wrapper">
      <div class="modal product-details-modal">
        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["show", "cancel"],
};
</script>
